/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitPartialYesNoEnum = {
    Yes: 'yes',
    No: 'no',
    Partial: 'partial'
} as const;
export type MonitPartialYesNoEnum = typeof MonitPartialYesNoEnum[keyof typeof MonitPartialYesNoEnum];


export function MonitPartialYesNoEnumFromJSON(json: any): MonitPartialYesNoEnum {
    return MonitPartialYesNoEnumFromJSONTyped(json, false);
}

export function MonitPartialYesNoEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPartialYesNoEnum {
    return json as MonitPartialYesNoEnum;
}

export function MonitPartialYesNoEnumToJSON(value?: MonitPartialYesNoEnum | null): any {
    return value as any;
}

